import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { UserNotificationPreference, UserNotificationPreferenceUpdate } from './user-notification';

/**
 * Service for the signed-in user's notification preferences in the current org. `UrlFixerService` rewrites
 * `/user/notifications` to `/user/<org-id>/notifications`.
 */
@Injectable()
export class UserNotificationService {

  /** API Url */
  private readonly apiUrl = `${environment.apiBaseUrl}/user/notifications`;

  public constructor(@Inject(HttpClient) private readonly http: HttpClient) {}

  /**
   * Gets the user's preference for every notification type they may set in the current org
   * @returns UserNotificationPreference[]
   */
  public search(): Observable<UserNotificationPreference[]> {
    return this.http.get<UserNotificationPreference[]>(this.apiUrl);
  }

  /**
   * Saves the posted preferences; types left out are unchanged
   * @param notifs Preferences to save
   * @returns The same list `search` would return
   */
  public update(notifs: UserNotificationPreferenceUpdate[]): Observable<UserNotificationPreference[]> {
    return this.http.post<UserNotificationPreference[]>(this.apiUrl, notifs);
  }

}
